import { render, staticRenderFns } from "./ProposalNumberCell.vue?vue&type=template&id=77aa7193&scoped=true"
import script from "./ProposalNumberCell.vue?vue&type=script&lang=js"
export * from "./ProposalNumberCell.vue?vue&type=script&lang=js"
import style0 from "./ProposalNumberCell.vue?vue&type=style&index=0&id=77aa7193&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa7193",
  null
  
)

export default component.exports